<template>

  <div class="flex justify-between">
    <span
      class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;TablaTotalesTodosCentros&gt;</span>
    <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">
      /api/v1/presupuesto/todoscentros/ </span>
  </div>


  <div v-if="loading" class="w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin">
  </div>
  <!-- Tabla -->
  <div class="overflow-x-auto flex justify-center items-center">


    <table class=" text-sm text-gray-700 font-mono w-[1200px]  ">

      <!-- THEAD -->
      <thead class="bg-gray-100 text-gray-600 uppercase  tracking-wide">
        <tr>
          <th class="text-left px-6 py-3 w-[380px]">Categoría  {{ tipo_categoria }}</th>
          <th class="text-center px-6 py-3  text-right">Presupuesto {{ año_abierto }}</th>
          <th class="text-center px-6 py-3  text-right">Gastos {{ año_abierto }}</th>
          <th class="px-6 py-3   ">% Ejecución {{ año_abierto }}</th>
          <th class="text-center px-6 py-3  text-right   bg-yellow-50">Presupuesto {{ año_borrador }} </th>

        </tr>
      </thead>

      <!-- TBODY -->
      <tbody>
        <tr v-for="(item, index) in filteredArray" :key="index" class="border-b hover:bg-gray-50 transition"
          :class="{ 'bg-gray-50': index % 2 !== 0 }">
          <!-- Nombre -->
          <td class="px-6 py-3   text-center font-mono text-gray-800">
            {{ getCategoriaActual(item.id)?.nombre || item.nombre }}

          </td>
          <!-- Presupuesto año_borrador anterior-->
          <td class="px-6 py-3   font-mono  text-right ">
            $ {{ $formatoMiles(getCategoriaActual(item.id)?.total_presupuesto || 0) }}


            <span @click="opemModalDetActual(item.id,
              getCategoriaActual(item.id)?.nombre || item.nombre
            )" class="cursor-pointer">[+]</span>

          </td>
          <td class="px-6 py-3    font-mono text-right">
            $ {{ $formatoMiles(array_presupuesto_categorias_año_actual[index]?.total_gastos || 0) }}


          </td>
          <!-- Porcentaje -->
          <td class="px-6 py-3 font-mono  ">
            <div class="flex items-center gap-3">

              <!-- Barra -->
              <div class="w-full bg-gray-200 rounded h-2 overflow-hidden">
                <div class="h-2 transition-all duration-300" :class="{
                  'bg-blue-500': array_presupuesto_categorias_año_actual[index]?.total_gastos / array_presupuesto_categorias_año_actual[index]?.total_presupuesto < 0.5,
                  'bg-yellow-500': array_presupuesto_categorias_año_actual[index]?.total_gastos / array_presupuesto_categorias_año_actual[index]?.total_presupuesto >= 0.5 && array_presupuesto_categorias_año_actual[index]?.total_gastos / array_presupuesto_categorias_año_actual[index]?.total_presupuesto < 0.8,
                  'bg-red-500': array_presupuesto_categorias_año_actual[index]?.total_gastos / array_presupuesto_categorias_año_actual[index]?.total_presupuesto >= 0.8
                }" :style="{
                  width: array_presupuesto_categorias_año_actual[index]?.total_presupuesto > 0
                    ? Math.min((array_presupuesto_categorias_año_actual[index]?.total_gastos / array_presupuesto_categorias_año_actual[index]?.total_presupuesto) * 100, 100) + '%'
                    : '0%'
                }"></div>
              </div>

              <!-- Texto porcentaje -->
              <span class="w-14 text-right">
                {{
                  array_presupuesto_categorias_año_actual[index]?.total_presupuesto > 0
                    ? ((array_presupuesto_categorias_año_actual[index]?.total_gastos /
                      array_presupuesto_categorias_año_actual[index]?.total_presupuesto) * 100).toFixed(1)
                    : 0
                }}%
              </span>

            </div>
          </td>

          <!-- Presupuesto -->
          <td class="px-6 py-3   font-mono  text-right text-gray-800  bg-yellow-100 ">


            $ {{ $formatoMiles(getCategoriaBorrador(item.id)?.total_presupuesto || 0) }}
            <span @click="opemModalDetBorrador(item.id,
              getCategoriaActual(item.id)?.nombre || item.nombre
            )" class="cursor-pointer">[+]</span>

          </td>


        </tr>

      </tbody>

      <!-- TFOOT -->
      <tfoot class="bg-gray-100">
        <tr>
          <td class="px-6 py-3 font-semibold text-gray-800  text-sm font-mono ">
            TOTAL GENERAL
          </td>
          <td class="px-6 py-3  font-semibold font-mono text-right  text-sm">
            $ {{ $formatoMiles(tot_tabla2.presupuestos) }}
          </td>

          <td class="px-6 py-3  font-semibold font-mono text-gray-700  text-right  text-sm">
            $ {{ $formatoMiles(tot_tabla2.gastos) }}
          </td>
          <td class="px-6 py-3   font-semibold font-mono text-gray-700  text-sm">
            {{ 
              tot_tabla2.presupuestos >0
              ?    ((tot_tabla2.gastos / tot_tabla2.presupuestos) * 100).toFixed(1)  
              : 0
             }}%
             
          </td>
          <td class="px-6 py-3   font-semibold font-mono text-gray-700 text-right  text-sm "> 
            
            $ {{
            $formatoMiles(tot_tabla1.presupuestos) }}</td>
        </tr>
      </tfoot>

    </table>

  </div>
 <!-- MODAL -->
  <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 ">
    <div class=" w-full   p-6">

      <div class="w-full max-w-6xl mx-auto p-6">
        <div class=" overflow-hidden  ">


          <div class="w-full max-w-6xl mx-auto p-6">
            <div class="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 h-[80vh] flex flex-col">

              <!-- Header (fijo) -->
              <div class="px-6 py-5 bg-gradient-to-r from-purple-600 via-pink-500 to-indigo-600 flex-shrink-0">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div class="p-2 bg-white/20 rounded-lg">
                      <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                    </div>
                    <div>
                      
                      <p class="text-lg font-semibold text-white">Presupuestos según centros / Categoría: {{ titulo_modal }}</p>
                    </div>
                  </div>
                  <div class="flex items-center gap-3">
                    <span class="px-3 py-1 bg-white/20 rounded-full text-sm text-white">
                      {{ det.centros.length }} centros
                    </span>
                    <span class="px-3 py-1 bg-white/20 rounded-full text-sm text-white">
                      {{ centrosConPresupuesto }} activos
                    </span>
                  </div>
                </div>
              </div>

              <!-- Tabla con div (scrollable) -->
              <div class="flex-1 min-h-0 overflow-hidden">
                <div class="h-full overflow-y-auto overflow-x-auto">

                  <!-- Header -->
                  <div
                    class="sticky top-0 z-10 bg-gray-50/80 border-b border-gray-200 grid grid-cols-12 gap-2 px-6 py-3">
                    <div class="col-span-1 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      #
                    </div>
                   
                     <div class="col-span-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                     Territorio  
                    </div>
                     <div class="col-span-2 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                       Centro
                    </div>
                    <div class="col-span-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Total Presupuestos
                    </div>
                    <div class="col-span-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Estado
                    </div>
                  </div>

                  <!-- Body -->
                  <div class="divide-y divide-gray-100">
                    <div v-for="(centro, index) in det.centros" :key="centro.centro_id"
                      class="grid grid-cols-12 gap-2 px-6 py-3 hover:bg-purple-50/50 transition-colors duration-150 group items-center">
                      <div class="col-span-1 text-sm text-gray-400 font-medium">
                        {{ String(index + 1).padStart(2, '0') }}
                      </div>
                     <div class="col-span-3">
                    <div class="grid grid-cols-2 gap-3 text-sm font-medium text-gray-700">
                     
                        {{ nombreClasificacionCentro(centro.clasificacioncentro_id) }}
                       
                    </div>
                  </div>
                        <div class="col-span-2">
                  
                      
                      <span class="text-right   ">
                        <b>{{ centro.nombre }}</b>
                      </span>
                    
                  </div>
                      <div class="col-span-3 text-right">
                        <span class="text-sm font-mono font-semibold"
                          :class="parseFloat(centro.total_presupuestos) > 0 ? 'text-gray-800' : 'text-gray-400'">
                         $ {{ $formatoMiles(centro.total_presupuestos) }}
                        </span>
                      </div>
                      <div class="col-span-3 text-center">
                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium" :class="parseFloat(centro.total_presupuestos) > 0
                          ? 'bg-green-100 text-green-800'
                          : 'bg-gray-100 text-gray-500'">
                          <span class="w-1.5 h-1.5 rounded-full mr-1.5"
                            :class="parseFloat(centro.total_presupuestos) > 0 ? 'bg-green-500' : 'bg-gray-400'">
                          </span>
                          {{ parseFloat(centro.total_presupuestos) > 0 ? 'Activo' : 'Sin presupuesto' }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Total (sticky bottom) -->
                  <div
                    class="sticky bottom-0 z-10 bg-gradient-to-r from-purple-50/80 to-indigo-50/80 border-t-2 border-purple-200 grid grid-cols-12 gap-2 px-6 py-4">
                    <div class="col-span-3 text-right">
                      <span class="text-sm font-semibold text-gray-700 flex items-center justify-end gap-2">

                        TOTAL GENERAL
                      </span>
                    </div>
                     <div class="col-span-3 text-right">
                      
                     </div>
                    <div class="col-span-4 text-right">
                      <div class="flex flex-col items-end">
                        <span class="text-2xl font-bold text-purple-700 font-mono">
                          $ {{ $formatoMiles(totalPresupuestos) }}
                        </span>
                        <span class="text-xs text-gray-400">
                          {{ centrosConPresupuesto }} centros con presupuesto
                        </span>
                      </div>
                    </div>
                    <div class=" text-center">
                      <span class="text-xs text-purple-600 font-medium">
                        {{ det.centros.length }} total
                      </span>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Footer (fijo) -->
              <div class="px-6 py-3 bg-gray-50/80 border-t border-gray-100 flex-shrink-0">

                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-4 text-xs text-gray-500">
                    <span>📊 {{ det.centros.length }} centros listados</span>
                    <span class="w-px h-4 bg-gray-300"></span>
                    <span>💰 {{ centrosConPresupuesto }} con presupuesto</span>
                    <span class="w-px h-4 bg-gray-300"></span>
                    <span>📭 {{ centrosSinPresupuesto }} sin presupuesto</span>
                  </div>
                  <div class="text-xs text-gray-400 flex items-center gap-1">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {{ new Date().toLocaleString('es-CL') }}
                    <button @click="showModal = false"
                      class="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm transition-colors">
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <div class="flex justify-end gap-2 mt-4">


      </div>
    </div>
  </div>
  
  <!-- -->
</template>
<script>

import api from "@/api/axios";
import { useCatPresup } from "@/composables/useCatPresup";
import { agrupa_categorias_suma_presupuestos2 } from "@/services/reporteria.services.js"
  
export default {
  name: 'ReporteriaPresupuestos',
  props: {
    date_time: {
        type: String      
    },
    capitalInvestment:{
        type: Boolean,
        default: false
    }
  },
  computed: {
    presupIndex() {
      const mapa = {}
      const mapa2 = {}

      this.presup_ctas.forEach(p => {
        const key = `${p.centro_id}-${p.categoria_id}`
        mapa[key] = p.total_presupuesto

        if (p.total_presupuesto > 0) {
          mapa2[key] = p.total_gastos * 100 / p.total_presupuesto
        } else {
          if (p.total_gastos > 0) {
            mapa2[key] = "100"
          }
        }

      })

      return { presupuesto: mapa, ejecucion: mapa2 }
    },

    presupIndexCategorias() {
      const mapa = {}

      this.array_presupuesto_categorias.forEach(p => {
        const key = `${p.id}`
        mapa[key] = p.total_presupuesto
      })

      return mapa
    },
    totIndexCategorias() {
      let mapa = 0


      console.log('-->', this.array_presupuesto_categorias)
      /**
       * [
{
   "id": 1,
   "nombre": "GASTOS DEL PERSONAL",
   "orden": 1,
   "total_gastos": 546997585,
   "total_presupuesto": 2332152398.2
},
{
   "id": 2,
   "nombre": "HONORARIOS",
   "orden": 2,
   "total_gastos": 88913071,
   "total_presupuesto": 529550760
} 
]
       */
      this.array_presupuesto_categorias.forEach(p => {
        mapa += p.total_presupuesto
      })


      return { total_presupuesto: mapa }
    },

    totPresupIndex() {
      const mapa = {}
      const mapa2 = {}

      // this.presup_ctas = [{ "categoria_id": 8, "centro_id": 29, "total_presupuesto": 6800000, "total_gastos": 0 },] 
      // reccorre y suma total  
      this.presup_ctas.forEach(p => {
        const key = `${p.centro_id}`
        if (mapa[key] == null) {
          mapa[key] = 0;
        }
        mapa[key] += p.total_presupuesto
      })


      return { presupuesto: mapa, ejecucion: mapa2 }
    },

    tot_tabla1() {
      return this.array_presupuesto_categorias.reduce(
        (acc, item) => {
          acc.presupuestos += Number(item?.total_presupuesto || 0);
          acc.gastos += Number(item?.total_gastos || 0);

          return acc;
        },
        { presupuestos: 0, gastos: 0 }
      );
    },
    tot_tabla2() {
      return this.array_presupuesto_categorias_año_actual.reduce(
        (acc, item) => {
          acc.presupuestos += Number(item?.total_presupuesto || 0);
          acc.gastos += Number(item?.total_gastos || 0);

          return acc;
        },
        { presupuestos: 0, gastos: 0 }
      );


    },

    mesesDisponibles() {
      const mesActual = new Date().getMonth() + 1
      return Array.from({ length: mesActual }, (_, i) => i + 1)
    },

    clasificacionesUsuario() {
      const usuario = this.clasificacion_unicos.find(
        item => item.user_id === this.selectedUserId
      );

      if (!usuario) return [];

      return usuario.clasificacioncentro_id.map(id => ({ id, nombre: this.nombreclasificacion[id] }));

    },
    centrosUsuarios() {
      if (!this.selectedClasificacionCentro) {
        return [];
      }
      const mapa = new Map();

      this.centros_responsables
        .filter(
          centro =>
            centro.clasificacioncentro_id === this.selectedClasificacionCentro &&
            centro.user.id === this.selectedUserId
        )
        .forEach(centro => {
          mapa.set(centro.id, {
            id: centro.id,
            nombre: centro.nombre
          });
        });

      return Array.from(mapa.values());
    },
    categoriasUsuario() {
      const categoriasUsuario = this.categorias.map(cat => ({
        id: cat.id,
        nombre: cat.nombre
      }))
      return categoriasUsuario
    },
    tiposCtaUsuario() {
      if (!this.selectedCategoria) {
        return [];
      }

      // método map() se usa en arreglos (arrays) y crea un nuevo arreglo aplicando una función a cada elemento del arreglo original. No modifica el arreglo original.
      const tipos = this.categorias
        .find(cat => cat.id === this.selectedCategoria)
        ?.tipos.map(tipo => ({
          id: tipo.id,
          nombre: tipo.nombre
        })) || [];
      return tipos;
    },

    cuentasUsuario() {
      let cuentas = [];

      if (this.selectedCategoria == 0 && this.selectedTipo == 0) {
        cuentas = this.categorias.flatMap(categoria =>
          categoria.tipos.flatMap(tipo =>
            tipo.cuentas.map(cuenta => ({
              id: cuenta.id,
              nombre: cuenta.nomcta,
              cod: cuenta.cod
            }))
          )
        );
      } else {
        if (this.selectedCategoria > 0 && this.selectedTipo == 0) {
          cuentas = this.categorias.find(cat => cat.id === this.selectedCategoria)
            ?.tipos.flatMap(tipo =>

              tipo.cuentas.map(cuenta => ({
                id: cuenta.id,
                nombre: cuenta.nomcta,
                cod: cuenta.cod
              }))
            ) || [];

        } else {
          if (this.selectedCategoria > 0 && this.selectedTipo > 0) {
            cuentas =
              this.categorias.find(cat => cat.id === this.selectedCategoria)
                ?.tipos.find(tipo => tipo.id === this.selectedTipo)
                ?.cuentas.map(cuenta => ({
                  id: cuenta.id,
                  nombre: cuenta.nomcta,
                  cod: cuenta.cod
                })) || [];

          }
        }
      }




      cuentas.sort((a, b) => a.nombre.localeCompare(b.nombre));

      return cuentas;

    },
    filteredArray() {
      return this.array_categ_base.filter((_, index) => {
        return this.array_presupuesto_categorias_año_actual[index]?.total_presupuesto || this.array_presupuesto_categorias[index]?.total_presupuesto
      })
    },
    totalPresupuestos() {
       console.log("centros:",this.det.centros)
      return this.det.centros.reduce((sum, centro) => {
        return sum + parseFloat(centro.total_presupuestos || 0)
      }, 0)
    },
    centrosConPresupuesto() {
      return this.det.centros.filter(c => parseFloat(c.total_presupuestos) > 0).length
    },
    centrosSinPresupuesto() {
      return this.det.centros.filter(c => parseFloat(c.total_presupuestos) === 0).length
    }

  },
  components: {

  },
  mounted() {
    this.año_borrador = this.$store.state.auth.userLogin.año_borrador
    this.año_abierto = this.$store.state.auth.userLogin.año
    this.superUser = this.$store.state.auth.userLogin.modifica_presupuestos;
    this.user_id = this.$store.state.auth.userLogin.id;
    if (this.user_id == 6) {
      this.userEsCeciliaBrahm = true
    }
    this.loadCentros()
    this.categoriasAgrupadas()
  },
  methods: {
      nombreClasificacionCentro( clasificacioncentro_id ){
      const  c=JSON.parse(process.env.VUE_APP_CLASIF_CENTRO)
      return  c[clasificacioncentro_id] 
    },
    nombreCentro(centro_id) {
      return this.$store.state.centros.centros.find(centro => centro.id === centro_id)
    },
    getCategoriaActual(categoriaId) {
      return this.array_presupuesto_categorias_año_actual.find(
        actual => actual.id === categoriaId
      );
    },
    getCategoriaBorrador(categoriaId) {
      return this.array_presupuesto_categorias.find(
        borrador => borrador.id === categoriaId
      );
    },
    loadCentros() {
      const cc = this.$store.state.centros.centros
      // filtra solo C.C con RESPONSABLE asignado
      this.centros = cc.filter(c => c.usuarios && c.usuarios.length > 0);

      let autorizado = false
      if (this.superUser) {
        autorizado = true
      } else {
        if (this.userEsCeciliaBrahm) {
          autorizado = true;
        }
      }



      if (!autorizado) {
        /**
         *this.centros {
                "id": 60,
                "codigo": "PMA056000000000",
                "nombre": "Megatransecto",
                "tiene_presupuesto": true,
                "clasificacioncentro_id": 1,
                "user": {
                    "id": 11,
                    "first_name": "Mathias",
                    "last_name": "HÜNE"
                },
                "usuarios": [
                    {
                        "id": 11,
                        "first_name": "Mathias",
                        "last_name": "HÜNE"
                    },
                    {
                        "id": 6,
                        "first_name": "Cecilia",
                        "last_name": "Brahm"
                    },
                  
                    {
                        "id": 18,
                        "first_name": "OscaR",
                        "last_name": "Aguilera"
                    }
                ]
            }
         */
        this.centros.sort((a, b) => {
          const ua = a.clasificacioncentro_id ?? Infinity;
          const ub = b.clasificacioncentro_id ?? Infinity;
          return ua - ub;
        });


      } else {

        // solo para Super-Usuarios: listado de centros agrupado por usuario

        this.centros_responsables = []
        this.centros_responsables = cc.filter(c => c.user?.id > 0);

        this.centros_responsables.sort((a, b) => {
          const ua = a.user?.id ?? Infinity;
          const ub = b.user?.id ?? Infinity;
          return ua - ub;
        });



        // ordena por clasificacioncentro y orden
        this.centros.sort(
          (a, b) =>
            a.clasificacioncentro_id - b.clasificacioncentro_id ||
            a.orden - b.orden ||
            a.user.id - b.user.id
        )

      }


    },
    async categoriasAgrupadas() {
      console.log('VIE PROCESSS',this.ID_CATEGORIA_INVERSIONES)
      /**
  contenido de this.$store.state.cuentas.cuentas  
  [
  {
     "id":65,
     "codigo":"4510308032",
     "nombre":"Agua",
     "tipo_cuenta":{
        "id":14,
        "nombre":"SERVICIOS BASICOS",
        "categoria_cuenta":{
           "id":8,
           "nombre":"GASTOS GENERALES",
           "orden":3
        }
     }
  },
       */
      //INICIO --------------------------------------------
      // extraer listado de categorias para la tabla html
      // en el TEMPLATE se iterará este listado de categorias  si hay presupuesto en el año actual o en el borrador
      let ctas;
      const allctas = this.$store.state.cuentas.cuentas
      if (this.capitalInvestment) {
        ctas = allctas.filter(
          cta => cta.tipo_cuenta?.categoria_cuenta?.id === parseInt(this.ID_CATEGORIA_INVERSIONES)
        );
      }else{
        ctas = allctas.filter(
          cta => cta.tipo_cuenta?.categoria_cuenta?.id !== parseInt(this.ID_CATEGORIA_INVERSIONES)
        );
      }


      const categoriasMap = {};
      ctas.forEach(cuenta => {
        const categoria = cuenta.tipo_cuenta.categoria_cuenta;
        // Usar el id como clave para evitar duplicados

        if (this.capitalInvestment) 
        {


          if (!categoriasMap[categoria.id] && categoria.id === parseInt(this.ID_CATEGORIA_INVERSIONES)) {
            categoriasMap[categoria.id] = {
              id: categoria.id,
              nombre: categoria.nombre,
              orden: categoria.orden
            };
          }

        } else {

          if (!categoriasMap[categoria.id] && categoria.id !== parseInt(this.ID_CATEGORIA_INVERSIONES)) {
            categoriasMap[categoria.id] = {
              id: categoria.id,
              nombre: categoria.nombre,
              orden: categoria.orden
            };
          }
        }
      });

      this.array_categ_base = Object.values(categoriasMap)
        .sort((a, b) => a.orden - b.orden);
      // FIN ------------------------------------------------------

      // recupera cuentas con presupuestos ingresados
      this.loading = true;
      this.loading2 = true;
      this.loading_responsables = true;

      try {
        let autorizado = false;
        let data = {}

        if (this.superUser) {
          autorizado = true
        } else {
          if (this.userEsCeciliaBrahm) {
            autorizado = true;
          }
        }


        if (!autorizado) {
          data = {
            user_id: this.user_id
          }
        }

        const response_año_abierto = await api.post("api/v1/presupuesto/todoscentros/", data, {
          headers: {
            "Content-Type": "application/json",

          },
        });
        if (response_año_abierto.status == 200) {
          
          const obj = agrupa_categorias_suma_presupuestos2(response_año_abierto.data.presupuestos, ctas)
          this.array_presupuesto_categorias_año_actual = obj.array_presupuesto_categorias
          this.array_detalle_centros_año_actual = obj.array_detalle_centros[0]


          /*
          return{ 
            'categorias'
            'array_presupuesto_categorias' 
            'presup_ctas' 
          } 
          */
        }
        data["borrador"] = true
        // trae presupuestos con o sin movimiento
        const response_año_borrador = await api.post("api/v1/presupuesto/todoscentros/", data, {
          headers: {
            "Content-Type": "application/json",

          },
        });

        if (response_año_borrador.status === 200) {

          if (response_año_borrador.data?.presupuestos){

            const borrador = agrupa_categorias_suma_presupuestos2(response_año_borrador.data.presupuestos, ctas)
            console.log('borrador',borrador)
          
            this.array_presupuesto_categorias = borrador?.array_presupuesto_categorias
            this.array_detalle_centros_año_borrador = borrador?.array_detalle_centros[0]

          }

          this.loading = false

          /**
          contenido: array_presupuesto_categorias  
           {
            "nombre": "COMUNICACIONES SATELITALES",
            "total_gastos": 1678862,
            "total_presupuesto": 20437000
          }
          ,{
          "nombre": "INVERSIONES",
          "total_gastos": 0,
          "total_presupuesto": 0
          }
           */

        }


      } catch (e) {
        console.error("Credenciales inválidas ?", e);
      }




    },
    async listCategoriasCuentas() {

      this.loading = true;
      // recupera cuentas con presupuestos ingresados

      let presupuestos;
      try {
        let data = {
          "centro_id": this.centro_id
        };
        if (this.categoria_id) {
          data.categoria_id = this.categoria_id
        }
        // solo trae presupuestos > 0
        const response = await api.post("api/v1/presupuestos/centro/", data, {
          headers: {
            "Content-Type": "application/json",

          },
        });

        if (response.status === 200) {

          presupuestos = response.data.presupuestos;

          /*  
          contiene el mismo centro_id
          en todos sus registros

          los cuenta_id no se repiten
           
          "presupuestos": 
          [
               {
                   "id": 5816,
                   "centro_id": 6,
                   "cuenta_id": 8,
                   "empresa_id": 1,
                   "aa": 2025,
                   "moneda_id": 1,
                   "total_presupuesto": "900000.00",
                   "total_gastos": "0.00"
               },
               
             v/s   this.$store.state.cuentas.cuentas
             [{
               "id":112,
               "codigo":"4.5.1030.80.44",
               "nombre":"Alarma",
               "tipo_cuenta":{
               "id":13,
               "nombre":"GTOS BASICOS CASAS E INSTALACIONES",
               "categoria_cuenta":{
                   "id":8,
                   "nombre":"GASTOS GENERALES"
               }
               }
             */

          this.total_presupuesto_centro = presupuestos.reduce(
            (acumulador, item) => {
              return acumulador + Number(item.total_presupuesto)
            }, 0)


          const cuentas = this.$store.state.cuentas.cuentas;
          const { getCatPresup } = useCatPresup()
          this.categoriasCuentas = getCatPresup(presupuestos, cuentas);

          //this.date_time = new Date().toISOString()

          this.loading = false;

          /*
       [{
         "id": 1,
         "nombre": "GASTOS DEL PERSONAL",
         "tipos": [
             {
                 "id": 1,
                 "nombre": "GASTOS DEL PERSONAL",
                 "cuentas": [
                     {
                         "id": 5,
                         "cod": "4510301005",
                         "nomcta": "Alimentacion del personal",
                         "total_presupuesto": "4507981.00",
                         "total_gastos": "0.00",
                         "saldo": 4507981
                     },
                     {
                         "id": 6,
                         "cod": "4510301006",
                         "nomcta": "Beneficios al Personal",
                         "total_presupuesto": "900020.00",
                         "total_gastos": "0.00",
                         "saldo": 900020
                     } 
                         
                     
                     
                */


        }

        this.presupuesto_categorias = this.categorias.map(grupo => ({
          nombre: grupo.nombre,
          total_presupuesto: grupo.tipos.flatMap(t => t.cuentas).reduce((acc, c) => acc + Number(c.total_presupuesto), 0)
        }));



      } catch (e) {
        console.error("Credenciales inválidas ?", e);
      }




    },
    detalle(centro_id, categoria_id) {

      const centros = this.$store.state.centros.centros;
      this.prop_obj_centro = centros.find(cc => cc.id === centro_id) || {};
      this.prop_categoria_id = categoria_id;
      this.celda_seleccionada = `${centro_id}-${categoria_id}`
      this.centro_id = centro_id
      this.categoria_id = categoria_id
      const centros_state = this.$store.state.centros.centros
      /*this.$store.state.centros.centros: [
              {
                  "id": 2,
                  "codigo": "PRO048000000000",
                  "nombre": "Infraestructura Conaf Pumalin",
                  "tiene_presupuesto": true,
                  "usuarios": []
              },*/
      this.objCentroSeleccionado = centros_state.find(cc => cc.id === centro_id);
      this.responsable_firstname = this.objCentroSeleccionado?.user?.first_name
      this.responsable_lastname = this.objCentroSeleccionado?.user?.last_name
      this.listCategoriasCuentas();


    },


    creaClasificacionesUnicas(responsables_y_cuentas) {

      const mapaUsuarios = new Map();

      responsables_y_cuentas.forEach(item => {

        let usuarios = [];

        // user puede ser objeto o array
        if (item.user) {
          usuarios = usuarios.concat(
            Array.isArray(item.user)
              ? item.user
              : [item.user]
          );
        }



        usuarios.forEach(usuario => {

          if (!mapaUsuarios.has(usuario.id)) {
            mapaUsuarios.set(usuario.id, {
              user_id: usuario.id,
              clasificacioncentro_id: []
            });
          }

          const registro = mapaUsuarios.get(usuario.id);

          if (
            !registro.clasificacioncentro_id.includes(
              item.clasificacioncentro_id
            )
          ) {
            registro.clasificacioncentro_id.push(
              item.clasificacioncentro_id
            );
          }
        });
      });

      const resultado = Array.from(mapaUsuarios.values());


      return resultado
    },

    opemModalDetActual(categoria_id, nomcat) {

      this.det = this.array_detalle_centros_año_actual.find(det => det.categoria_id === categoria_id)
      const centro_y_prespuesto = this.det.centros
      const centros = this.$store.state.centros.centros
      // 1) Recorrer array 'centro_y_presupuesto'
      centro_y_prespuesto.forEach(item => {
        // 2) Buscar si el centro_id existe en el array centros
        const centroEncontrado = centros.find(centro => centro.id === item.centro_id);

        // 3) Si existe, extraer y agregar los campos al objeto
        if (centroEncontrado) {
          item.clasificacioncentro_id = centroEncontrado.clasificacioncentro_id;
          item.codigo = centroEncontrado.codigo;
          item.nombre = centroEncontrado.nombre;
        }
      });

      // 4) Ordenar objetos en centro_y_presupuesto
      // Primer criterio: clasificacioncentro_id (ascendente)
      // Segundo criterio: nombre (ascendente)
      centro_y_prespuesto.sort((a, b) => {
        // Primero ordenar por clasificacioncentro_id
        if (a.clasificacioncentro_id !== b.clasificacioncentro_id) {
          return a.clasificacioncentro_id - b.clasificacioncentro_id;
        }
        // Si son iguales, ordenar por nombre
        return a.nombre.localeCompare(b.nombre);
      });




      this.titulo_modal = `${nomcat} ${this.año_abierto}`

      this.showModal = true
    },
    opemModalDetBorrador(categoria_id, nomcat) {

      this.det = this.array_detalle_centros_año_borrador.find(det => det.categoria_id === categoria_id)
  const centro_y_prespuesto = this.det.centros
      const centros = this.$store.state.centros.centros
      // 1) Recorrer array 'centro_y_presupuesto'
      centro_y_prespuesto.forEach(item => {
        // 2) Buscar si el centro_id existe en el array centros
        const centroEncontrado = centros.find(centro => centro.id === item.centro_id);

        // 3) Si existe, extraer y agregar los campos al objeto
        if (centroEncontrado) {
          item.clasificacioncentro_id = centroEncontrado.clasificacioncentro_id;
          item.codigo = centroEncontrado.codigo;
          item.nombre = centroEncontrado.nombre;
        }
      });

      // 4) Ordenar objetos en centro_y_presupuesto
      // Primer criterio: clasificacioncentro_id (ascendente)
      // Segundo criterio: nombre (ascendente)
      centro_y_prespuesto.sort((a, b) => {
        // Primero ordenar por clasificacioncentro_id
        if (a.clasificacioncentro_id !== b.clasificacioncentro_id) {
          return a.clasificacioncentro_id - b.clasificacioncentro_id;
        }
        // Si son iguales, ordenar por nombre
        return a.nombre.localeCompare(b.nombre);
      });


      this.titulo_modal = `${nomcat} ${this.año_borrador}`

      this.showModal = true
    }

  },
  data() {
    return {
      colapsado1: true,
      colapsado2: true,
      colapsado3: true,
      colapsado4: true,
      centros: [],
      tipo_categoria: this.capitalInvestment ? 'CAPITAL INVESTMENT 💼': 'OPERACIONAL 💵',
      ID_CATEGORIA_INVERSIONES : process.env.VUE_APP_ID_CATEGORIA_INVERSIONES,
      array_presupuesto_categorias: [],
      loading: false,
      loading2: false,
      presup_ctas: [],
      gastos_ctas: [],
      prop_obj_centro: false,
      prop_categoria_id: 0,
      solo_lectura: true,
      celda_seleccionada: '',
      categorias: {},
      categoriasCuentas: {},
      centro_id: 0,
      categoria_id: 0,
      superUser: false,
      user_id: 0,
      objCentroSeleccionado: {},
      responsable_firstname: '',
      responsable_lastname: '',
      cuentaExpandida: [],
      colores: [

        "#dbfff7", // MARINE PROGRAM
        "#bfe5ff", // CAPE FROWARD NATIONAL PARK
        "#ffdbde", // CERRO CASTILLO NATIONAL PARK
        "#fcffe0", // PATAGONIA NATIONAL PARK
        "#aaffc8", // PUMALÍN DOUGLAS TOMPKINS NATIONAL PARK
        "#fff69e", //RUTA DE LOS PARQUES
        "#efc4fc", // GENERAL SUPPORT

      ],
      leyenda: [

        "Marine Program",
        "Cape Froward National Park",
        "Cerro Castillo National Park",
        "Patagonia National Park",
        "Pumalín Douglas Tompkins National Park",
        "Ruta de los Parques",
        "General Support"
      ],
      users_unicos: [],
      responsables_y_cuentas: [],
      solo_centro_responsable_cuentas: [],
      selectedUserId: 0,
      selectedMes: new Date().getMonth() + 1,
      loading_responsables: false,
      visibleModal: false,
      año_borrador: '',
      año_abierto: '',
      nombreclasificacion: JSON.parse(process.env.VUE_APP_CLASIF_CENTRO),
      userEsCeciliaBrahm: false,
      selectedClasificacionCentro: 0,
      selectedCentro: 0,
      selectedCategoria: 0,
      selectedTipo: 0,
      selectedCuenta: 0,
      array_presupuesto_categorias_año_actual: [],
      array_categ_base: [],
      array_detalle_centros_año_actual: [],
      array_detalle_centros_año_borrador: [],
      showModal: false,
      titulo_modal: '',
      categoria_modal: '',
      aa_modal: '',
      det: {}
    }


  },
  watch: {
      date_time: function(){
         this.categoriasAgrupadas()
      }
  }
}
</script>